import { useDebounceFn } from '@vueuse/core'

export const useElementSelector = <T = HTMLElement | null>(
	selector: string,
	onSelectCallback?: (...rest: any) => void
) => {
	const el = ref<HTMLElement | null>(null)

	const activate = useDebounceFn(() => {
		if (selector && import.meta.client) {
			el.value = document.querySelector(selector)
			onSelectCallback?.(el.value)
		}
	}, 100)
	const useSelector = <E = HTMLElement | null>(arg: string = selector): E | null => {
		if (arg && import.meta.client) {
			return document.querySelector(arg) as E
		}
		return null
	}
	onMounted(activate)
	return { el: el as Ref<T>, useSelector }
}
